import i18next from "../i18n";

let modalAccessibilityInitialized = false;

export default class View {
  _addressField = document.querySelector("#address");
  _addressForm = document.querySelector(".address-form");
  _birthdateValidationField = document.querySelector(".birthdate-validation");
  _birthDayField = document.querySelector("#birthday-day");
  _birthMonthField = document.querySelector("#birthday-month");
  _birthYearField = document.querySelector("#birthday-year");
  _blockProfile = document.querySelector(".block-profile");
  _btnDetailsDeliveryFee = document.querySelector(".details-delivery-fee");
  _cartDeliveryFee = document.querySelector(".cart-delivery-fee");
  _cartItems = document.querySelector(".item-row-cart");
  _cartRowDeliveryFee = document.querySelector("#cart-row-delivery-fee");
  _cartSubtotal = document.querySelector(".cart-subtotal");
  _cartTotalWithTip = document.querySelector(".checkout-total");
  _countryPhonePatterns = {
    "Côte d'Ivoire": {
      maxLength: 10,
      pattern: "^(01|05|07|21|25|27)[0-9]{8}$",
      placeholderKey: "validation.tenDigitNumber",
    },
    // We can add more countries here. Make sure the 'value' in the HTML <option>
    // matches the key in this object
  };
  _countrySelect = document.querySelector("#country");
  _dropdownList = document.querySelector(".dropdown-list");
  _emailField = document.querySelector("#email");
  _emailValidationField = document.querySelector(".email-validation");
  _errorContainer = document.querySelector(".error-message");
  // Create intersection observer by calling its constructor and passing it the callback function 'loadImg'
  _imgObserver = new IntersectionObserver(this.loadImg, {
    root: null,
    rootMargin: "200px",
    threshold: 0,
  });
  _imgTargets = document.querySelectorAll("img[data-src]");
  _loadingOverlay = document.querySelector(".loading-overlay");
  _modalBackgroundError = document.querySelector(".modal-background.error");
  _overlayCheckout = document.querySelector(".overlay-container.checkout");
  _overlayContainer = document.querySelectorAll(".overlay-container");

  _overlayError = document.querySelector(".overlay-container.error");
  _overlayItem = document.querySelector(".overlay-container.item");
  _overlaySearch = document.querySelector(".overlay-container.search");
  _overlayService = document.querySelector(".overlay-container.service");
  _phoneField = document.querySelector("#phone-number");
  _phoneNumberValidationField = document.querySelector(
    ".phone-number-validation",
  );

  _saveSuccessContainer = document.querySelector(".modal-container-success");
  _tipTotal = document.querySelector(".cart-tip");

  _tooltipContainerDeliveryFee = document.querySelector(
    ".tooltip-container-delivery-fee",
  );
  _tooltiptextDeliveryFee = document.querySelector(".tooltiptext-delivery-fee");

  /* Lazy loading images on main page (with intersection observer) */

  _clearModalError() {
    this._errorContainer.textContent = "";
  }

  // Close modal Checkout
  closeModalCheckout() {
    // Hide modal
    this._overlayCheckout.style.display = "none";

    // Show scroll bar and prevent scroll
    document.body.style.overflow = "visible";
  }

  // Close modal Error
  closeModalError() {
    this._modalBackgroundError.onclick = (e) => {
      if (e.target === this._modalBackgroundError) {
        // Hide error modal
        this._overlayError.style.display = "none";

        if (
          this._overlayItem?.style.display === "block" ||
          this._overlayService?.style.display === "block" ||
          this._overlayCheckout?.style.display === "block" ||
          this._overlaySearch?.style.display === "block"
        ) {
          // Hide scroll bar
          document.body.style.overflow = "hidden";
        } else {
          // Show scroll bar
          document.body.style.overflow = "visible";
        }
      }
    };
  }

  // Close modal on "Escape" key press
  closeModalOnEscape() {
    if (modalAccessibilityInitialized) {
      return;
    }
    modalAccessibilityInitialized = true;

    const dialogSelector =
      '.modal-container, [class^="modal-container-"], [class*=" modal-container-"]';
    const focusableSelector =
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    const getFocusableElements = (dialog) =>
      Array.from(dialog.querySelectorAll(focusableSelector)).filter((element) =>
        Boolean(element.getClientRects().length),
      );
    const getActiveDialog = () =>
      Array.from(this._overlayContainer)
        .filter((overlay) => getComputedStyle(overlay).display !== "none")
        .pop()
        ?.querySelector(dialogSelector);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach(({ target: overlay }) => {
        if (getComputedStyle(overlay).display === "none") {
          return;
        }

        const dialog = overlay.querySelector(dialogSelector);
        if (!dialog) {
          return;
        }

        dialog.setAttribute(
          "role",
          overlay.classList.contains("error") ? "alertdialog" : "dialog",
        );
        dialog.setAttribute("aria-modal", "true");
        dialog.setAttribute("tabindex", "-1");

        const firstFocusableElement = getFocusableElements(dialog).shift();
        (firstFocusableElement ?? dialog).focus();
      });
    });

    this._overlayContainer.forEach((overlay) =>
      observer.observe(overlay, { attributeFilter: ["style"] }),
    );

    document.addEventListener("keydown", (event) => {
      const dialog = getActiveDialog();
      if (!dialog) {
        return;
      }

      if (event.key === "Escape") {
        this._overlayContainer.forEach((overlay) => {
          overlay.style.display = "none";
        });

        document.body.style.removeProperty("overflow");
        document.documentElement.style.removeProperty("overflow");
        document.body.style.removeProperty("height");
        return;
      }

      if (event.key !== "Tab") {
        return;
      }

      const focusableElements = getFocusableElements(dialog);
      const firstFocusableElement = focusableElements.shift() ?? dialog;
      const lastFocusableElement =
        focusableElements.pop() ?? firstFocusableElement;

      if (event.shiftKey && document.activeElement === firstFocusableElement) {
        event.preventDefault();
        lastFocusableElement.focus();
      } else if (
        !event.shiftKey &&
        document.activeElement === lastFocusableElement
      ) {
        event.preventDefault();
        firstFocusableElement.focus();
      }
    });
  }

  // Hide save modal Success
  closeSaveModalSuccess() {
    // Hide modal
    this._saveSuccessContainer.style.display = "none";
  }

  // Debounce method
  debounce(func, delayInMs) {
    let timeout;

    return (...args) => {
      if (timeout) {
        clearTimeout(timeout);
      }
      timeout = setTimeout(() => {
        // Call the original function with the right arguments
        func(...args);
      }, delayInMs);
    };
  }

  extractNumber(formattedString) {
    // Remove non-numeric characters (excluding the decimal point)
    const numericString = formattedString.replace(/[^0-9.-]+/gu, "");
    return parseFloat(numericString);
  }

  // Create our number formatter.
  formatCurrency(amount) {
    // Get the currency and locale dynamically from the DOM
    const currency = this.getCurrencyFromDOM();
    const currencyDisplayFromContext = this.getCurrencyDisplayFromDOM();
    const locale = this.getLocaleFromDOM();

    // Create an instance of Intl.NumberFormat with dynamic currency and locale
    // This ensures proper formatting (e.g., 1,000.00 vs 1 000,00) based on locale
    // Check "https://gist.github.com/g4rcez/e072eb9e1203679645985a9c89722117" for the complete list of currency
    const formatter = new Intl.NumberFormat(locale, {
      currency,
      style: "currency",
    });

    if (!currencyDisplayFromContext) {
      // Use Intl formatter output when no explicit display label is configured.
      return formatter.format(amount);
    }

    // Replace only the currency token, preserving locale number formatting.
    return formatter
      .formatToParts(amount)
      .map((part) =>
        part.type === "currency" ? currencyDisplayFromContext : part.value,
      )
      .join("");
  }

  // The server renders a formatted amount as a no-JS fallback; swap it here
  // for one in the visitor's own locale, using the raw number in data-amount.
  formatCurrencyElements(root = document) {
    root.querySelectorAll("[data-amount]").forEach((el) => {
      const amount = Number(el.dataset.amount);
      if (!Number.isNaN(amount)) {
        el.textContent = this.formatCurrency(amount);
      }
    });
  }

  /**
   * Get the currency display label from the DOM.
   * The display label is stored in a hidden div with id="app-context" and
   * data-currency-display attribute.
   * This value is cached to avoid repeated DOM queries.
   * @returns {string} The currency display label (e.g., "F CFA")
   */
  getCurrencyDisplayFromDOM() {
    // Cache the currency display label to avoid repeated DOM queries
    if (!this._cachedCurrencyDisplay) {
      const appContext = document.getElementById("app-context");
      this._cachedCurrencyDisplay =
        appContext?.dataset?.currencyDisplay?.trim();
    }
    return this._cachedCurrencyDisplay;
  }

  /**
   * Get the currency code from the DOM.
   * The currency is stored in a hidden div with id="app-context" and data-currency attribute.
   * This value is cached to avoid repeated DOM queries.
   * @returns {string} The currency code (e.g., "CAD", "XOF", "USD")
   */
  getCurrencyFromDOM() {
    // Cache the currency to avoid repeated DOM queries
    if (!this._cachedCurrency) {
      const appContext = document.getElementById("app-context");
      this._cachedCurrency = appContext?.dataset?.currency || "XOF";
    }
    return this._cachedCurrency;
  }

  getDateInTimezone(timezone, date = new Date()) {
    if (!timezone) {
      return new Date(date);
    }

    try {
      const locale = this.getLocaleFromDOM();
      const dateParts = new Intl.DateTimeFormat(locale, {
        day: "2-digit",
        hour: "2-digit",
        hourCycle: "h23",
        minute: "2-digit",
        month: "2-digit",
        second: "2-digit",
        timeZone: timezone,
        year: "numeric",
      }).formatToParts(date);

      const parts = dateParts.reduce((acc, part) => {
        if (part.type !== "literal") {
          acc[part.type] = part.value;
        }
        return acc;
      }, {});

      return new Date(
        `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}`,
      );
    } catch {
      return new Date(date);
    }
  }

  /**
   * Get the locale from the DOM.
   * The locale is stored in a hidden div with id="app-context" and data-locale attribute.
   * This value is cached to avoid repeated DOM queries.
   * @returns {string} The locale (e.g., "en-CA", "fr-CI", "en-US")
   */
  getLocaleFromDOM() {
    // Cache the locale to avoid repeated DOM queries
    if (!this._cachedLocale) {
      const appContext = document.getElementById("app-context");
      this._cachedLocale = appContext?.dataset?.locale || "fr-CI";
    }
    return this._cachedLocale;
  }

  getStoreId(selector = ".store-id-js") {
    const el = document.querySelector(selector);

    if (!el) {
      throw new Error(`Missing element: ${selector}`);
    }

    const MIN_STORE_ID = 0;

    // Get ID of store
    const raw = el.dataset.storeId;
    const id = Number(raw);

    if (!Number.isInteger(id) || id < MIN_STORE_ID) {
      throw new Error(`Invalid data-store-id: "${raw}"`);
    }
    return id;
  }

  getStoreLocationId(selector = ".store-address-js") {
    const el = document.querySelector(selector);

    if (!el) {
      throw new Error(`Missing element: ${selector}`);
    }

    const MIN_LOCATION_ID = 0;

    // Get ID of store
    const raw = el.dataset.locationId;
    const id = Number(raw);

    if (!Number.isInteger(id) || id < MIN_LOCATION_ID) {
      throw new Error(`Invalid data-location-id: "${raw}"`);
    }
    return id;
  }

  getTimeFromDate(date) {
    const TIMEFORMATLENGTH = 2;
    const hours = String(date.getHours()).padStart(TIMEFORMATLENGTH, "0");
    const minutes = String(date.getMinutes()).padStart(TIMEFORMATLENGTH, "0");
    return `${hours}:${minutes}`;
  }

  hideLoadingSpinner() {
    this._loadingOverlay.classList.remove("active");
  }

  initPhoneNumberLogic() {
    this._countrySelect.addEventListener(
      "change",
      this.updatePhoneNumberPattern.bind(this),
    );
    // Ensure that the phone number input's pattern, placeholder, and max length
    // are correctly set for the default selected country on page load.
    this.updatePhoneNumberPattern();
  }

  isClosingDay(currentDate, closingDays) {
    // Get the day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
    const currentDay = currentDate.getDay();

    // Check if the current day is in the closing days array
    return closingDays.includes(currentDay);
  }

  isTimeBetween(currentTime, startTime, endTime) {
    const HOURINDEX = 0;
    const MINUTEINDEX = 1;
    const HOURS_IN_DAY = 24;
    const MINUTES_IN_HOUR = 60;

    const [currentHour, currentMinute] = currentTime.split(":").map(Number);
    const [startHour, startMinute] = startTime.split(":").map(Number);
    let endHour = Number(endTime.split(":")[HOURINDEX]);
    const endMinute = Number(endTime.split(":")[MINUTEINDEX]);

    // Adjust endTime if it's before startTime
    if (
      endHour < startHour ||
      (endHour === startHour && endMinute < startMinute)
    ) {
      // Add 24 hours to endHour
      endHour += HOURS_IN_DAY;
    }

    const currentTimeInMinutes = currentHour * MINUTES_IN_HOUR + currentMinute;
    const startTimeInMinutes = startHour * MINUTES_IN_HOUR + startMinute;
    const endTimeInMinutes = endHour * MINUTES_IN_HOUR + endMinute;

    return (
      currentTimeInMinutes >= startTimeInMinutes &&
      currentTimeInMinutes <= endTimeInMinutes
    );
  }

  isTimeWithinAnySlot(currentTime, timeSlots) {
    for (let i = 0; i < timeSlots.length; i++) {
      const [startTime, endTime] = timeSlots[i];
      if (this.isTimeBetween(currentTime, startTime, endTime)) {
        // Current time falls within one of the time slots
        return true;
      }
    }
    // Current time doesn't fall within any time slot
    return false;
  }

  // Callback function of the intersection observer
  loadImg(entries, observer) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        return;
      }

      // Replace src with data-src
      entry.target.src = entry.target.dataset.src;

      // Unobserve target element
      observer.unobserve(entry.target);
    });
  }

  // Show modal checkout after completing delivery details
  openModalCheckout() {
    // Show checkout modal
    this._overlayCheckout.style.display = "block";

    // Ensure any other modal closes whenever service modal opens
    this._overlayService.style.display = "none";
    this._overlayItem.style.display = "none";

    // Hide scroll bar and prevent scroll
    document.body.style.overflow = "hidden";
  }

  // Open modal Error
  openModalError() {
    // Show modal
    this._overlayError.style.display = "block";

    // Hide scroll bar
    document.body.style.overflow = "hidden";
  }

  // Open modal Delivery Service
  openModalService() {
    // Show modal
    this._overlayService.style.display = "block";

    // Ensure any other modal closes whenever service modal opens
    this._overlayCheckout.style.display = "none";
    this._overlayItem.style.display = "none";

    // Hide scroll bar and prevent scroll
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
    document.body.style.height = "100%";
    document.documentElement.style.height = "100%";
  }

  // Open modal Delivery Service
  openModalServiceDelivery() {
    const addressFormTemplate = `
    <div class="address-container">
      <label for="address" class="label-input"
      >${i18next.t("labels.address")} <span class="required-field"> * </span> </label>
      <input
        type="text"
        class="user-input w-input"
        maxlength="256"
        name="address"
        placeholder=""
        id="address"
        required
        autocomplete="off"
      />
      <span class="address-validation" aria-live="polite"
        >${i18next.t("validation.completeAddress")}
      </span>
      <div class="result-address"></div>
    </div>
    <label for="apartment" class="label-input">${i18next.t("validation.apt")}</label>
    <input
      type="number"
      min="0"
      class="user-input w-input"
      name="apartment"
      placeholder=""
      id="apartment"
    />
`;

    // Clear address form
    this._addressForm.innerHTML = "";

    // Insert the template litteral into the delivery form
    this._addressForm.innerHTML = addressFormTemplate;

    // Show modal
    this._overlayService.style.display = "block";

    // Ensure any other modal closes whenever service modal opens
    this._overlayCheckout.style.display = "none";
    this._overlayItem.style.display = "none";

    // Hide scroll bar and prevent scroll
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
    document.body.style.height = "100%";
    document.documentElement.style.height = "100%";
  }

  // Open modal Pickup Service
  openModalServicePickup() {
    // Clear address form
    this._addressForm.innerHTML = "";

    // Show modal
    this._overlayService.style.display = "block";

    // Ensure any other modal closes whenever service modal opens
    this._overlayCheckout.style.display = "none";
    this._overlayItem.style.display = "none";

    // Hide scroll bar and prevent scroll
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
    document.body.style.height = "100%";
    document.documentElement.style.height = "100%";
  }

  // Open save modal Success
  openSaveModalSuccess() {
    // Show modal
    this._saveSuccessContainer.style.display = "flex";

    // Ensure any other modal closes whenever save modal opens
    this._overlayError.style.display = "none";
  }

  renderSaveError(message = i18next.t("error.saveChanges")) {
    this._clearModalError();
    this._errorContainer.textContent = message;
    this.openModalError();

    // Ensure any other modal closes whenever error modal opens
    this.closeSaveModalSuccess();
  }

  // Validating group of checkboxes
  requireAtLeastOneCheck(element) {
    const DEFAULTINDEX = 0;
    const SCROLLPADDING = 20;
    const SHAKEDURATION = 1000;
    const MIN_ELEMENT_LENGTH = 0;

    let atLeastOneChecked = false;

    for (let i = 0; i < element.length; i++) {
      if (element[i].checked) {
        atLeastOneChecked = true;
        break;
      }
    }

    if (atLeastOneChecked) {
      for (let i = 0; i < element.length; i++) {
        element[i].required = false;
      }
    } else if (element.length > MIN_ELEMENT_LENGTH) {
      element[DEFAULTINDEX].required = true;
      element[DEFAULTINDEX].style.scrollMargin = `${
        document.querySelector(".option-header-container").offsetHeight +
        SCROLLPADDING
      }px`;

      element[DEFAULTINDEX].scrollIntoView({ behavior: "smooth" });

      // Closest ancestor element with the class of "option-container-js"
      const wrapper = element[DEFAULTINDEX]?.closest(".option-container-js");

      // Shake wrapper element
      wrapper.classList.add("shake");

      // Remove the shake class after 3 seconds
      setTimeout(() => {
        wrapper.classList.remove("shake");
      }, SHAKEDURATION);
    }

    return atLeastOneChecked;
  }

  showLoadingSpinner() {
    this._loadingOverlay.classList.add("active");
  }

  testEmail(email) {
    const re = /\S+@\S+\.\S+/u;
    return re.test(email);
  }

  toggleMenu() {
    if (!this._blockProfile || !this._dropdownList) {
      return;
    }

    // Open dropdown menu on click and toggle its visibility
    this._blockProfile.onclick = (e) => {
      e.stopPropagation();
      this._dropdownList.classList.toggle("w--open");
    };

    // Close the dropdown menu if clicked outside of it
    document.addEventListener("click", (e) => {
      e.stopPropagation();

      if (!this._dropdownList) {
        return;
      }

      // Check if the clicked element is not part of the dropdown toggle button
      if (!e.target.closest(".w-icon-dropdown-toggle")) {
        // Close the dropdown menu if it is currently open
        if (this._dropdownList.classList.contains("w--open")) {
          this._dropdownList.classList.remove("w--open");
        }
      }
    });
  }

  // Interact with tooltip
  tooltipHandleDeliveryFee() {
    const HIDE_TIMEOUT_MS = 5000;
    let hideTooltipTimeout;

    // Elements to add event listeners to
    const elements = [
      this._btnDetailsDeliveryFee,
      this._tooltipContainerDeliveryFee,
    ];

    // Show tooltip on hover
    elements.forEach((el) => {
      el.onmouseover = (e) => {
        e.stopPropagation();
        this._tooltiptextDeliveryFee.style.visibility = "visible";
        this._tooltiptextDeliveryFee.style.opacity = "1";
        this._tooltiptextDeliveryFee.style.pointerEvents = "auto";
      };
    });

    // Show tooltip  on click
    elements.forEach((el) => {
      el.onclick = (e) => {
        // Clear any pending timeout
        clearTimeout(hideTooltipTimeout);

        e.stopPropagation();
        this._tooltiptextDeliveryFee.style.visibility = "visible";
        this._tooltiptextDeliveryFee.style.opacity = "1";
        this._tooltiptextDeliveryFee.style.pointerEvents = "auto";

        // Hide tool tip after 5 seconds to ensure that it gets closed for mobile users
        hideTooltipTimeout = setTimeout(() => {
          this._tooltiptextDeliveryFee.style.visibility = "hidden";
          this._tooltiptextDeliveryFee.style.opacity = "0";
          this._tooltiptextDeliveryFee.style.pointerEvents = "none";
        }, HIDE_TIMEOUT_MS);
      };
    });

    // Close tooltip on mouse out
    elements.forEach((el) => {
      el.onmouseout = (e) => {
        e.stopPropagation();
        this._tooltiptextDeliveryFee.style.visibility = "hidden";
        this._tooltiptextDeliveryFee.style.opacity = "0";
        this._tooltiptextDeliveryFee.style.pointerEvents = "none";
      };
    });

    // Close tooltip when clicking outside of it
    document.addEventListener("click", (e) => {
      e.stopPropagation();
      // Check if the clicked element is not part of the tooltip text
      if (!e.target.closest(".tooltiptext")) {
        if (this._tooltiptextDeliveryFee.style.visibility === "visible") {
          this._tooltiptextDeliveryFee.style.visibility = "hidden";
          this._tooltiptextDeliveryFee.style.opacity = "0";
          this._tooltiptextDeliveryFee.style.pointerEvents = "none";
        }
      }
    });
  }

  updatePhoneNumberPattern() {
    const selectedCountryCode = this._countrySelect.value;
    const phoneData = this._countryPhonePatterns[selectedCountryCode];

    if (phoneData) {
      this._phoneField.pattern = phoneData.pattern;
      this._phoneField.placeholder = i18next.t(phoneData.placeholderKey);
      this._phoneField.maxLength = phoneData.maxLength;
    } else {
      // Fallback if no country is selected
      this._phoneField.pattern = ".+";
      this._phoneField.placeholder = i18next.t("form.phoneNumberPrompt");
      this._phoneField.maxLength = 15;
    }

    // Clear any custom validation messages
    this._phoneField.setCustomValidity("");

    // Hide validation message
    this._phoneNumberValidationField.style.display = "none";
  }

  // Validate birthdate
  validateBirthdate(event) {
    const birthDay = this._birthDayField.value;
    const birthMonth = this._birthMonthField.value;
    const birthYear = this._birthYearField.value;

    const notValid =
      (birthDay || birthMonth || birthYear) &&
      (!birthDay || !birthMonth || !birthYear);

    if (notValid) {
      const SHAKEDURATION = 1000;
      const birthdateContainer = document.querySelector(
        ".full-birthdate-field",
      );

      // Show birthdate validation field
      this._birthdateValidationField.style.display = "block";

      // Shake element
      birthdateContainer.classList.add("shake");

      // Remove the 'shake' class after shakeDuration milliseconds
      setTimeout(() => {
        birthdateContainer.classList.remove("shake");
      }, SHAKEDURATION);

      // Prevent form submission
      event.preventDefault();

      return false;
    }

    // Hide birthdate validation field
    this._birthdateValidationField.style.display = "none";
    return true;
  }

  // Validate email
  validateEmail(event) {
    // Check if the email doesn't match the pattern
    if (!this.testEmail(this._emailField.value)) {
      const SHAKEDURATION = 1000;
      const emailContainer = document.querySelector(".email-container");

      // Show email validation field
      this._emailValidationField.style.display = "block";

      // Shake element
      emailContainer.classList.add("shake");

      // Remove the 'shake' class after shakeDuration milliseconds
      setTimeout(() => {
        emailContainer.classList.remove("shake");
      }, SHAKEDURATION);

      // Prevent form submission
      event.preventDefault();

      return false;
    }

    // Hide email validation field
    this._emailValidationField.style.display = "none";
    return true;
  }

  // Validate phone number
  validatePhoneNumber(event) {
    // Get the current pattern from the input's pattern attribute
    const currentPattern = new RegExp(this._phoneField.pattern, "u");

    // Check if the phone number doesn't match the current pattern
    if (!currentPattern.test(this._phoneField.value)) {
      const SHAKEDURATION = 1000;
      const phoneNumberContainer = document.querySelector(
        ".block-phone-number",
      );

      // Show phone number validation field
      this._phoneNumberValidationField.style.display = "block";

      // Shake element
      phoneNumberContainer.classList.add("shake");

      // Remove the 'shake' class after 1 second
      setTimeout(() => {
        phoneNumberContainer.classList.remove("shake");
      }, SHAKEDURATION);

      // Prevent form submission
      event.preventDefault();

      return false;
    }

    // If phone number matches the pattern, hide validation error
    this._phoneNumberValidationField.style.display = "none";
    return true;
  }

  // Watch target element whenever the target meets the threshold
  watchImg() {
    this._imgTargets.forEach((img) => {
      if (img.dataset.src !== "") {
        this._imgObserver.observe(img);
      }
    });
  }
}
